import React, {useState, useRef, useEffect} from 'react';
import styles from './Tooltip.module.css';

const Tooltip = ({text, children, link, backgroundColor, displayedOnBottom = false}) => {
    const [hovered, setHovered] = useState(false);
    const [tooltipStyle, setTooltipStyle] = useState({});
    const [arrowStyle, setArrowStyle] = useState({});
    const tooltipRef = useRef(null);
    const hideTimer = useRef(null);          // ⬅ 记录隐藏定时器

    const showTooltip = () => {
        clearTimeout(hideTimer.current);       // 若正在等待隐藏则取消
        setHovered(true);
    };

    const hideTooltip = () => {
        hideTimer.current = setTimeout(() => setHovered(false), 150);
    };

    useEffect(() => {
        return () => clearTimeout(hideTimer.current); // 组件卸载时清理
    }, []);
    useEffect(() => {
        if (hovered && tooltipRef.current) {
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            const {innerWidth, innerHeight} = window;

            const offset = 8;
            let newStyle;
            if (displayedOnBottom) { //翻转到下方
                newStyle = {
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bottom: 'auto',
                    top: '100%',
                };
            } else {
                newStyle = {
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bottom: '120%',
                    top: 'auto',
                };
            }

            let newArrowStyle = {
                left: '50%',
                transform: 'translateX(-50%)',
            };


            let shiftX = 0;

            if (tooltipRect.left < offset) {
                shiftX = offset - tooltipRect.left;
            } else if (tooltipRect.right > innerWidth - offset) {
                shiftX = -(tooltipRect.right - (innerWidth - offset));
            }


            newStyle.transform = `translateX(calc(-50% + ${shiftX}px))`;

            let arrowShiftX = -shiftX;
            newArrowStyle.transform = `translateX(calc(-50% + ${arrowShiftX}px))`;


            if (tooltipRect.top < offset) {
                newStyle.bottom = 'auto';
                newStyle.top = '100%';
            } else if (tooltipRect.bottom > innerHeight - offset) {
                newStyle.top = 'auto';
                newStyle.bottom = '120%';
            }

            setTooltipStyle(newStyle);
            setArrowStyle(newArrowStyle);
        } else {
            setTooltipStyle({});
            setArrowStyle({});
        }
    }, [hovered]);

    return (
        <div
            className={styles.tooltipWrapper}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
        >
            {children}

            {hovered && (
                <div
                    className={styles.tooltip}
                    ref={tooltipRef}
                    style={{
                        ...tooltipStyle,
                        '--tooltip-bg': backgroundColor
                    }}
                >
                    {text}
                    {link && (
                        <a
                            href={link}
                            target="_blank"
                            rel="noreferrer"
                            className={styles.learnMoreLink}
                        >
                            Learn More
                        </a>
                    )}
                    <div
                        className={styles.arrow}
                        style={arrowStyle}
                    />
                </div>
            )}
        </div>
    );
};

export default Tooltip;